import { render, staticRenderFns } from "./UserIdsSection.vue?vue&type=template&id=14590b86&"
import script from "./UserIdsSection.vue?vue&type=script&lang=js&"
export * from "./UserIdsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports